// Robot pictures for device cards. Drop a file in assets/images/manufacturer named
// <manufacturer>_<model>.png (lowercase) and it is used for every device with that
// manufacturer and model. The model is tried in this order:
//   1. devices.model_number    lionsbot_r3.png   (Lionsbot robotFamily "R3")
//   2. devices.model
//   3. the model code in the RC UUID (second part of rc_device_id):
//      BOSC-BCRD-... -> bosch_bcrd.png (Spotless), BOSC-BCR2-... -> bosch_bcr2.png
//      (Spotless 2), SAMS-JETB-... -> samsung_jetb.png
// Falls back to <manufacturer>_icon.png, then to null (the card shows a placeholder).

function loadImages() {
  try {
    // webpack (react-scripts) bundles every image in the folder at build time
    const context = require.context(
      "../assets/images/manufacturer",
      false,
      /\.(png|jpe?g|webp|svg)$/i,
    );
    return context.keys().reduce((images, key) => {
      const name = key.replace(/^\.\//, "").replace(/\.[^.]+$/, "").toLowerCase();
      const module = context(key);
      images[name] = module?.default || module;
      return images;
    }, {});
  } catch {
    // require.context is not available outside webpack (e.g. Jest)
    return {};
  }
}

const IMAGES = loadImages();

const toKey = (value) =>
  String(value || "")
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "_")
    .replace(/^_+|_+$/g, "");

export function getDeviceImage(device) {
  const manufacturer = toKey(device?.manufacturer);
  if (!manufacturer) return null;

  // "Samsung Electronics" -> also try "samsung"
  const manufacturers = [manufacturer, manufacturer.split("_")[0]];
  const uuidModelCode = String(device?.rc_device_id || "").split("-")[1];
  const models = [device?.model_number, device?.model, uuidModelCode]
    .map(toKey)
    .filter(Boolean);
  for (const maker of manufacturers) {
    for (const model of models) {
      if (IMAGES[`${maker}_${model}`]) return IMAGES[`${maker}_${model}`];
    }
  }
  for (const maker of manufacturers) {
    if (IMAGES[`${maker}_icon`]) return IMAGES[`${maker}_icon`];
  }
  return null;
}
